import React, { useRef } from 'react';
import { COLORS } from '@/components/ui/ui.constants';

interface GradientSpinnerProps {
  color?: string;
  size?: number;
}

let nextId = 0;

const GradientSpinner = ({ color = COLORS['tci-purple'], size = 18 }: GradientSpinnerProps) => {
  const gradientId = useRef(`gradient-spinner-${++nextId}`).current;

  return (
    <svg
      aria-hidden="true"
      className="tw-animate-spin"
      height={size}
      viewBox="0 0 18 18"
      width={size}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0" />
          <stop offset="100%" stopColor={color} stopOpacity="1" />
        </linearGradient>
      </defs>
      <circle
        cx="9"
        cy="9"
        fill="none"
        r="7"
        stroke={`url(#${gradientId})`}
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </svg>
  );
};

export default GradientSpinner;
